// ========================================================
// FAST HIT Website — Public Layout Shell
// Wraps public-facing pages (landing, features, scores, etc.)
// ========================================================

import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from '../common/ScrollToTop';
import { CookieConsentBanner } from '../common/CookieConsentBanner';

export function PublicLayout() {
  return (
    <>
      <ScrollToTop />
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="main-content">
        <Outlet />
      </main>
      <Footer />
      <CookieConsentBanner />
    </>
  );
}
